import { YoutubePlatform } from '@app/modules/social-export/domain/platforms';
import { PlatformMultiConnect } from '../../../screens/manage/connect/PlatformMultiConnect';
import { youtubeConnectAlternatives } from './youtube-connect-alternatives';

/** YouTube multi-method connect: opens alternatives dialog (basic + advanced). */
export function YoutubeConnect() {
  return (
    <PlatformMultiConnect platform={YoutubePlatform} alternatives={youtubeConnectAlternatives} />
  );
}
